import {
  BudgetExpenseDraftSummary,
  BudgetExpenseMatrixResult,
} from 'interfaces/BudgetExpenseLine';
import {
  CloseRevisionParams,
  CreateLineParams,
  DraftSummaryParams,
  MatrixParams,
  UpsertCellParams,
  applyFromMonth,
  closeRevision,
  createLine,
  deleteLine,
  draftSummary,
  matrix,
  recreateFromPreviousYear,
  upsertCell,
} from './calls';

export * from './calls';

export default class BudgetExpenseLineAPICaller {
  static matrix = async (params: MatrixParams) => {
    const { data } = await matrix(params);

    return data as BudgetExpenseMatrixResult;
  };

  static createLine = async (params: CreateLineParams) => {
    const { data } = await createLine(params);

    return data;
  };

  static upsertCell = async (params: UpsertCellParams) => {
    const { data } = await upsertCell(params);

    return data;
  };

  static applyFromMonth = async (params: UpsertCellParams) => {
    const { data } = await applyFromMonth(params);

    return data;
  };

  static closeRevision = async (params: CloseRevisionParams) => {
    const { data } = await closeRevision(params);

    return data;
  };

  static deleteLine = async (params: CloseRevisionParams) => {
    const { data } = await deleteLine(params);

    return data;
  };

  static recreateFromPreviousYear = async (year: number) => {
    const { data } = await recreateFromPreviousYear(year);

    return data as { created: number };
  };

  static draftSummary = async (params: DraftSummaryParams) => {
    const { data } = await draftSummary(params);

    return data as BudgetExpenseDraftSummary;
  };
}
